import React from 'react';
import '../../styles/transport.css'; // Import Hero specific CSS
import '../../styles/Fonts.css'; // Import Fonts specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

const benefitsData = [
  {
    number: '01',
    title: 'Trusted',
    description: 'Provides expert knowledge of regulations, customs, and safety protocols for smooth transport.',
    icon: 'fa-check-circle' // Font Awesome icon name for this benefit
  },
  {
    number: '02',
    title: 'Cost Efficiency',
    description: 'Reduced transportation costs through route optimization, shipment consolidation, and carrier negotiations.',
    icon: 'fa-solid fa-hand-holding-dollar' // Font Awesome icon name for this benefit
  },
  {
    number: '03',
    title: 'Scalability',
    description: 'Easily scale services based on business needs, handling seasonal demand surges or adjusting to varying shipment sizes.',
    icon: 'fa-chart-line' // Font Awesome icon name for this benefit
  },
  {
    number: '04',
    title: 'Accurate Deliveries',
    description: 'With organized systems and real-time tracking, ensure timely deliveries to meet customer expectations and deadlines.',
    icon: 'fa-shipping-fast' // Font Awesome icon name for this benefit
  }
];

const TransportBenefits = () => {
  return (
    <>
      {/* Transport Benefits Section */}
      <section id="benefits" className="services-preview-section">
        <div className="container">
          <div className="section-header">
            <div className="section-badge">WHY CHOOSE US</div>
            <h2 className="section-title">Transport Benefits</h2>
            <p className="section-description">
              Discover the key advantages of partnering with RCS Logistics for your transportation needs.
            </p>
          </div>

          <div className="services-cards-grid transport-benefits">
            {benefitsData.map((benefit, index) => (
              <div key={index} className="service-card">
                <div className="service-card-icon">
                  <i className={`fas ${benefit.icon}`}></i>
                </div>
                <h3 className="service-card-title">{benefit.title}</h3>
                <p className="service-card-description">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default TransportBenefits;
